export default __webpack_public_path__ + "static/insta-1aba837db49c94e1111d87352ed568ad.png";